import { useState } from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import cn from 'clsx'
import { useForm } from 'react-hook-form'
import z from 'zod'

import { useAppDispatch } from '@App/hooks'
import { closeModal } from '@App/redux/slices/modals/ModalSlice'
import { asyncEditAccount } from '@App/redux/slices/user/UserSlice'
import { CloseIcon } from '@App/static/icons/ArrowIcons'

import { TradeInput } from '../../../pages/spot/components/SpotOrderTrade/components/TradeInput'
import { Button } from '../../controls/Button'
import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'


const MAX_NAME_LENGTH = 30
const formSchema = z.object({
  account_id: z.string(),
  name: z.string().max(MAX_NAME_LENGTH).min(1),
})

export const EditAccountNameModal = ({
  isOpen,
  setIsOpen,
  parent,
  id,
  name,
  setName,
}: ModalTypes & { id?: string; name: string; setName: (val: string) => void }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { register, watch, getValues } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      account_id: id!,
      name: name,
    },
  })
  const formName = watch('name')
  const dispatch = useAppDispatch()
  const submit = async () => {
    setIsLoading(true)
    const data = getValues()
    await dispatch(asyncEditAccount({ ...data, account_id: data.account_id as any as string }))
    setName(data.name)
    setIsOpen()
    setIsLoading(false)
  }
  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen} parent={parent}>
      <div
        className={s.container}
        onClick={(e) => {
          e.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
        }}
      >
        <div className={s.header}>
          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>
          <div className={s.title}>Edit account name</div>
          <TradeInput
            className={s.input}
            containerClassNames={s.inputContainer}
            {...register('name')}
            renderElements={(isFocus) => (
              <>
                <span className={cn(s.fieldName, isFocus && s.focus)}>Name</span>
                <span className={s.counter}>{MAX_NAME_LENGTH - formName.length}</span>
                <span className={s.accountType}>Live -</span>
              </>
            )}
          />

          <Button className={cn(s.btn, s.outlined, s.small)} onClick={submit} isLoading={isLoading}>
            Save
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
